import service from '@/utils/request';

/**
 * @Summary 获取订单的状态
 * @Security ApiKeyPaymet
 * @accept application/json
 * @Produce application/json
 * @Success 200 {string} json "{"success":true,"data":{},"msg":"获取成功"}"
 * @Router /payment/returnOrderStatus [get]
 * */
export var returnOrderStatus = function returnOrderStatus() {
  return service({
    url: '/payment/returnOrderStatus',
    method: 'get'
  });
};

/**
 * @Summary 获取收款订单的数据
 * @Success 200 {string} json "{"success":true,"data":{},"msg":"获取成功"}"
 * @Router /payment/payInList [post]
 * */
export var payInList = function payInList(data) {
  return service({
    url: '/payment/payInList',
    method: 'post',
    data: data
  });
};

/**
 * @Summary 获取付款订单的数据
 * @Success 200 {string} json "{"success":true,"data":{},"msg":"获取成功"}"
 * @Router /payment/payOutList [post]
 * */
export var payOutList = function payOutList(data) {
  return service({
    url: '/payment/payOutList',
    method: 'post',
    data: data
  });
};

/**
 * @Summary 推送收款订单通知
 * @param data
 * @returns {AxiosPromise}
 */
export var payinPush = function payinPush(data) {
  return service({
    url: '/payment/reNotifyPayIn',
    method: 'post',
    data: data
  });
};
export var manualDisputePayIn = function manualDisputePayIn(data) {
  return service({
    url: '/payment/manualDisputePayIn',
    method: 'post',
    data: data
  });
};

/**
 * @summary
 * @param data
 * @returns {AxiosPromise}
 */
export var payOutPush = function payOutPush(data) {
  return service({
    url: '/payment/reNotifyPayOut',
    method: 'post',
    data: data
  });
};
export var payInOutExcel = function payInOutExcel(data) {
  return service({
    url: "/payment/payInOutExcel",
    method: 'post',
    data: data
  });
};
export var payOutOutExcel = function payOutOutExcel(data) {
  return service({
    url: '/payment/withDrawExcel',
    method: 'post',
    data: data
  });
};
export var getSuccessRateLimit = function getSuccessRateLimit() {
  return service({
    url: '/payment/getSuccessRateLimit',
    method: 'post'
  });
};
export var getChannelMaxCost = function getChannelMaxCost(data) {
  return service({
    url: '/payment/getChannelMaxCost',
    method: 'post',
    data: data
  });
};
export var getWeightStatus = function getWeightStatus() {
  return service({
    url: '/payment/getWeightStatus',
    method: 'post'
  });
};
export var getChangeLog = function getChangeLog() {
  return service({
    url: '/payment/getChangeLog',
    method: 'post'
  });
};
export var getMethodList = function getMethodList() {
  return service({
    url: '/payment/getMethodList',
    method: 'post'
  });
};
export var getPayWeight = function getPayWeight(data) {
  return service({
    url: '/payment/getPayWeight',
    method: 'post',
    data: data
  });
};
export var changeWeightAutoStatus = function changeWeightAutoStatus(data) {
  return service({
    url: '/payment/changeWeightAutoStatus',
    method: 'post',
    data: data
  });
};
export var successRateLimit = function successRateLimit(data) {
  return service({
    url: '/payment/successRateLimit',
    method: 'post',
    data: data
  });
};
export var editWeightAllInOne = function editWeightAllInOne(data) {
  return service({
    url: '/payment/editWeightAllInOne',
    method: 'post',
    data: data
  });
};
export var getNowWeightList = function getNowWeightList(data) {
  return service({
    url: '/payment/getNowWeightList',
    method: 'post',
    data: data
  });
};
export var setChannelMaxCost = function setChannelMaxCost(data) {
  return service({
    url: '/payment/setChannelMaxCost',
    method: 'post',
    data: data
  });
};

// 获取多套数据
export var showEditManualScheme = function showEditManualScheme(data) {
  return service({
    url: '/payment/showEditManualScheme',
    method: 'post',
    data: data
  });
};
export var editManualScheme = function editManualScheme(data) {
  return service({
    url: '/payment/editManualScheme',
    method: 'post',
    data: data
  });
};
export var delEditManualScheme = function delEditManualScheme(data) {
  return service({
    url: '/payment/delEditManualScheme',
    method: 'post',
    data: data
  });
};
export var queryPayOutOrder = function queryPayOutOrder(data) {
  return service({
    url: '/payment/queryPayOutOrder',
    method: 'post',
    data: data
  });
};
export var getErrorChannel = function getErrorChannel() {
  return service({
    url: '/payment/getErrorChannel',
    method: 'post'
  });
};
export var upByErrorChannel = function upByErrorChannel(data) {
  return service({
    url: '/payment/upByErrorChannel',
    method: 'post',
    data: data
  });
};
export var getPayLimitInfo = function getPayLimitInfo() {
  return service({
    url: '/payment/getPayLimitInfo',
    method: 'post'
  });
};
export var editPaymentLimitInfo = function editPaymentLimitInfo(data) {
  return service({
    url: '/payment/editPaymentLimitInfo',
    method: 'post',
    data: data
  });
};
export var operatorHitListOrder = function operatorHitListOrder(data) {
  return service({
    url: '/payment/operatorHitListOrder',
    method: 'post',
    data: data
  });
};
export var showHitList = function showHitList(data) {
  return service({
    url: '/payment/showHitList',
    method: 'post',
    data: data
  });
};
export var queryCancelStaticQr = function queryCancelStaticQr(data) {
  return service({
    url: '/payment/queryCancelStaticQr',
    method: 'post',
    data: data
  });
};
export var getHitListType = function getHitListType() {
  return service({
    url: '/payment/getHitListType',
    method: 'post'
  });
};
export var addHitList = function addHitList(data) {
  return service({
    url: '/payment/addHitList',
    method: 'post',
    data: data
  });
};
export var delFromHitList = function delFromHitList(data) {
  return service({
    url: '/payment/delFromHitList',
    method: 'post',
    data: data
  });
};
export var showPayLineData = function showPayLineData(data) {
  return service({
    url: '/payment/showPayLineData',
    method: 'post',
    data: data
  });
};

/**
 * @description 编辑商户的权重列表
 */
export var editWeightMerchantInfo = function editWeightMerchantInfo(data) {
  return service({
    url: '/payment/editWeightMerchantInfo',
    method: 'post',
    data: data
  });
};

/**
 * @description 获取商户的权重列表
 */
export var getWeightMerchantInfo = function getWeightMerchantInfo() {
  return service({
    url: '/payment/getWeightMerchantInfo',
    method: 'post'
  });
};